import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  RefundPaymentEntity,
  OpenItemEntity,
} from "src/app/components/accounting/open-item/models/open-item-list.model";
import { proposalCommon } from "src/app/components/new-product/base/utils/proposal-common";
import {
  v1DlgInputArgs,
  MdConfirmationMessageV1Component,
} from "src/app/components/shared/partials/md-confirmation-message-v1/md-confirmation-message-v1.component";
import { dlgModelArgs } from "src/app/components/shared/partials/md-confirmation-message-v2/md-confirmation-message-v2.component";
import { OpenItemStatus } from "src/app/finance/finance-enums";
import { RefundPaymentType } from "src/app/framework/enum.shared";
import { common } from "src/app/framework/utils/common";
import { CdkDialogService } from "src/app/services/dialog/cdk-dialog.service";
import { OpenItemListService } from "src/app/services/open-item-list.service";

@Component({
    selector: "mf-hk-do-refund",
    templateUrl: "./mf-hk-do-refund.component.html",
    styleUrls: ["./mf-hk-do-refund.component.scss"],
    standalone: false
})
export class MfHkDoRefundComponent implements OnInit {
  public refundPayment = new RefundPaymentEntity();
  public openItemId!: string;
  public openItemEntity = new OpenItemEntity();
  public totalPremium: any;
  public active = false;
  public opened: boolean = false;

  refundType!: RefundPaymentType;
  refundTypeDisplayText!: string;

  @Input() public set model(openItemEntity: any) {
    this.refundPayment.openItemId = openItemEntity.openItemId;
  }
  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() doRefund: EventEmitter<RefundPaymentEntity> = new EventEmitter();
  //validation
  invalidRequiredField = false;
  invalidPayerName = false;
  invalidCIB = false;
  invalidCN = false;
  invalidRemark = false;

  constructor(
    private cdkDialogService: CdkDialogService,
    private openItemListService: OpenItemListService
  ) {}

  ngOnInit(): void {
    this.getOpenItemDetails();
  }
  public onCancel(e: PointerEvent): void {
    e.preventDefault();
    this.closeForm();
  }
  private getOpenItemDetails() {
    this.openItemListService
      .getOpenItem(this.refundPayment.openItemId)
      .subscribe((response: OpenItemEntity) => {
        const openItem: OpenItemEntity = response;
        this.active = openItem !== undefined;
        this.openItemEntity = openItem;
        // this.refundType =
        //   openItem.statusId === OpenItemStatus.PendingRefundToBankInReview
        //     ? RefundPaymentType.OnlineTransfer
        //     : openItem.statusId ===
        //       OpenItemStatus.PendingRefundToIndividualInReview
        //     ? RefundPaymentType.Cheque
        //     : RefundPaymentType.Undefined;
        //only OpenItemStatus.PendingRefundToBankInReview(22) maps to Refunded (9), in sproc UpdateOpenItem
        this.refundType = RefundPaymentType.OnlineTransfer;
        const refundTypeDisplayText: string =
          proposalCommon.translateRefundPaymentType(this.refundType);
        this.refundTypeDisplayText = refundTypeDisplayText;
        this.refundPayment.refundPaymentType = this.refundType;
      });
  }
  public closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }

  ConfirmationPopup(msg: string, data: any) {
    let v1InputData: v1DlgInputArgs = {
      opened: true,
      dialogWidth: 600,
      data: data,
      message: msg,
    };

    const v1DialogRef = this.cdkDialogService.open(
      MdConfirmationMessageV1Component,
      {
        data: v1InputData,
      }
    );

    v1DialogRef.afterClosed().subscribe((result: any) => {
      // Subscription runs after the dialog closes
      if (result) {
        this.confirmationModalCloseForActions(result);
      }
    });
  }

  public onSave(e: PointerEvent): void {
    this.invalidRequiredField = false;
    const isValid: boolean = this.validateMandatoryFields();
    if (isValid) {
      this.ConfirmationPopup(
        "Are you sure you want to refund this payment?",
        ""
      );
    } else {
      this.invalidRequiredField = true;
      e.preventDefault();
    }
  }
  private validateMandatoryFields(): boolean {
    let hasError: boolean = false;
    // validate mandatory fields
    if (common.isStringNullOrEmpty(this.refundPayment.payerName)) {
      hasError = true;
      this.invalidPayerName = true;
    } else {
      this.invalidPayerName = false;
    }

    return !hasError;
  }
  async confirmationModalCloseForActions(args: dlgModelArgs) {
    if (args.status === "yes") {
      this.doRefund.emit(this.refundPayment);
    }
  }
}
